import { render, staticRenderFns } from "./PostsLoop.vue?vue&type=template&id=0e495d3e&"
import script from "./PostsLoop.vue?vue&type=script&lang=js&"
export * from "./PostsLoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports